import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-16 shrink-0 bg-white shadow justify-start items-center inline-flex fixed z-50" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 6H20M4 12H20M4 18H20",
    stroke: "#003463",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"grow shrink basis-0 self-stretch flex-col justify-center items-center gap-2.5 inline-flex\"></div><button class=\"flex w-16 self-stretch px-4 justify-start items-center\"><div class=\"w-8 h-8 relative bg-gray-100 rounded-2xl\"><svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_227_340)\"><rect width=\"32\" height=\"32\" rx=\"16\" fill=\"#F3F4F6\"></rect><path d=\"M32 27.992V32.0013H0V28.0067C1.86127 25.5193 4.27721 23.5004 7.05572 22.1107C9.83423 20.721 12.8987 19.9987 16.0053 20.0013C22.544 20.0013 28.352 23.14 32 27.992ZM21.336 12C21.336 13.4145 20.7741 14.771 19.7739 15.7712C18.7737 16.7714 17.4172 17.3333 16.0027 17.3333C14.5882 17.3333 13.2316 16.7714 12.2314 15.7712C11.2312 14.771 10.6693 13.4145 10.6693 12C10.6693 10.5855 11.2312 9.22895 12.2314 8.22875C13.2316 7.22856 14.5882 6.66666 16.0027 6.66666C17.4172 6.66666 18.7737 7.22856 19.7739 8.22875C20.7741 9.22895 21.336 10.5855 21.336 12Z\" fill=\"#D1D5DB\"></path></g><defs><clipPath id=\"clip0_227_340\"><rect width=\"32\" height=\"32\" rx=\"16\" fill=\"white\"></rect></clipPath></defs></svg><span class=\"absolute flex items-center justify-center -right-2 -top-2 text-[10px] text-white h-5 w-5 rounded-full bg-primary ring-2 ring-white\"> 9+ </span></div></button>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menuComponent = _resolveComponent("menuComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("button", {
        class: "flex w-16 self-stretch justify-center items-center",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open()))
      }, _hoisted_3),
      _hoisted_4
    ]),
    _createVNode(_component_menuComponent, {
      openMenu: _ctx.openMenu,
      "onUpdate:openMenu": _ctx.close
    }, null, 8, ["openMenu", "onUpdate:openMenu"])
  ], 64))
}